import { IDocumentCategory, isTitleSearchName } from '../../types/order/documents/IDocumentCategoryType';

export const vendorTitleSearchDocumentsLabels = (category: IDocumentCategory, isOptional = false): string => {
  if (isTitleSearchName(category.name)) {
    return 'Search Report & Title Commitment Finalized';
  } else {
    return `${isOptional ? '[Optional] ' : ''}Upload ${category.label}`;
  }
};

export const taxCertificationDocuments: string[] = ['TaxCertificate'];
